import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export interface ResourceSwitchProps {
  options: { label: string; to: string }[];
  active: string;
  label?: string;
}

/** Use to switch between sibling resource routes that share one sidebar entry; rendered as navigation links. */
export function ResourceSwitch({ options, active, label = 'Switch view' }: ResourceSwitchProps) {
  return (
    <nav aria-label={label} className="inline-flex gap-1 rounded-lg bg-muted p-1">
      {options.map((o) => (
        <Link
          key={o.to}
          to={o.to}
          aria-current={o.to === active ? 'page' : undefined}
          className={cn(
            'rounded-md px-3 py-1 text-sm font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring',
            o.to === active ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {o.label}
        </Link>
      ))}
    </nav>
  );
}
